import { render, staticRenderFns } from "./Header.component.html?vue&type=template&id=16dce3c4&"
import script from "./Header.component.ts?vue&type=script&lang=ts&"
export * from "./Header.component.ts?vue&type=script&lang=ts&"
import style0 from "./Header.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports